export enum ConnectionState {
    Disconnected,
    Upgrading,
    Connecting,
    Connected
}
